<div
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'Premium Access'"
  class="dialog flex flex-row items-start"
  [class.dialog--compact]="(breakpoint$ | async) <= breakPoints.Medium"
  data-test="premiumAccessDialog">
  <div class="flex items-center justify-center flex-auto">
    <div class="dialog__content flex flex-row items-start justify-center flex-auto">
      <app-callout-content
        [content]="data"
        [compact]="(breakpoint$ | async) <= breakPoints.Medium"
        (actionClick)="handleActionClick()"
        (secondaryActionClick)="handleSecondaryActionClick()">
      </app-callout-content>
    </div>
  </div>

  <button
    class="drawer__close"
    app-button
    buttonType="default"
    buttonTheme="light"
    type="button"
    (click)="handleCloseClick()"
    title="Close"
    [attr.aria-label]="'Close'"
    class="modal__close">
    <app-icon icon="times" size="lg"> </app-icon>
  </button>
</div>
